import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { addcart } from './Cartslice'
import { FaHeart } from "react-icons/fa";

const Products = () => {

  const dispatch = useDispatch()

  const [products, setProducts] = useState(null)
  const [loading, setLoading] = useState(null)
  useEffect(() => {
    axios.get('https://dummyjson.com/product')
      .then(function (response) {
        // handle success
        console.log(response.data);
        setProducts(response.data.products)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }, [])

  useEffect(() => {
    axios.get('https://dummyjson.com/products/categories')
      .then(function (response) {
        // handle success
        console.log(response.data);
        setLoading(response.data)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }, [])
  const cartBtn = (n) => {
    axios.get('https://dummyjson.com/products/category/' + n)
      .then(function (response) {
        // handle success
        console.log(response.data);
        setProducts(response.data.products)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }
  return (

    <>

     <div>
     <Container fluid>
        <Row>
          <Col xs={6} lg={3}>
            <Row>
              {
                loading == null ? 'loading......!' : loading.map((v, i) => {
                  return (
                    <Col xs={12}>
                      <div key={i}>
                        <h2 className='fs-5 text-uppercase bg-dark text-white px-3 py-4 ' onClick={() => { cartBtn(v.name) }}>{v.name}</h2><br />
                      </div>
                    </Col>
                  )
                })
              }
            </Row>
          </Col>
          <Col xs={6} lg={9}>
            <Container>
              <Row>
                {
                  products == null ? 'loading.....!' : products.map((v, i) => {
                    return (
                      <Col xs={12} sm={6} lg={4}>
                        <center className='box'>
                          <div className='iteam_box mt-3 iteam_img p-2 ' key={1}>
                            <img src={v.thumbnail} alt="" />
                            <div>
                              <span className='fs-5 fw-bold title'>{v.title}</span><br />
                              <span>category={v.category}</span><br />
                              <span>price={v.price}</span><br />
                              <span>rating={v.rating}</span><br />
                              <div className='d-flex justify-content-between'>
                                <button className='px-4 mt-2 bg-white'><Link className='text-decoration-none text-capitalize text-dark fw-bold' to={`/products/${v.id} `}>Deatails</Link></button>&nbsp;&nbsp;
                                <Link><button className='px-4 mt-2 btn text-dark ' onClick={() => { dispatch(addcart(v)) }}><FaHeart /></button></Link>
                              </div>
                            </div>
                          </div>
                        </center>
                      </Col>
                    )
                  })
                }
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
     </div>
    </>
  )
}

export default Products